<template>
  <div v-show="value">
    <!--优惠券选择-->
    <van-popup v-model="showCoupon" round @closed="closed" @opened="opened"
               position="bottom" style="height: 80vh" class="has-btn-bottom"
    >
      <van-tabs v-model="active">
        <van-tab title="可用优惠券">
          <ul style="height: calc(80vh - 94px); overflow-y: auto">
            <li v-for="temp in usable" :Key="temp.id"
                class="flex-between coupon" @click="selectCoupon(temp)"
            >
              <div class="ph-2x flex-grow">
                <h4>{{ temp.product.name }}</h4>
                <div class="flex-start">
                  <p class="font-s mt-x flex-shrink" v-if="temp.product.card_least_cost"> 购满{{ temp.product.card_least_cost }}元可用 </p>
                  <p class="font-s mt-x flex-shrink" v-else> 无门槛 </p>
                  <p class="font-s mt-x pl-1x text-nowrap-1"> {{ temp.product.remark }} </p>
                </div>
                <p class="font-s mt-x">每日使用时段: {{ temp.product.time_start }} ~ {{ temp.product.time_start }}</p>
                <p class="font-s mt-x"
                   v-if="temp.product.card_date_type === 'RANGE'"
                >{{ temp.product.card_start_date | date }}至{{ temp.product.card_end_date | date }}有效
                </p>
                <p class="font-s mt-x" v-else>
                  <span v-if="temp.product.card_fixed_begin_term">领取{{ temp.product.card_fixed_begin_term }}天后生效,</span>
                  <span v-else>领取后立即生效,</span>
                  <span>生效后{{ temp.product.card_fixed_term }}天内使用</span>
                </p>
              </div>
              <div class="action pv-1x text-c flex-shrink" :style="{background: temp.product.card_color}">
                <div class="flex-center mt-3x white">
                  <p class="font-l mt-x">¥</p>
                  <h1 class="mh-x">{{ temp.product.unit_price }}</h1>
                </div>
                <ul class="gap">
                  <li class="circle" v-for="item in 11" :key="item"></li>
                </ul>

                <div class="select white">
                  <van-icon name="circle" size="24" v-show="!temp.selected" />
                  <van-icon name="checked" size="24" v-show="temp.selected" />
                </div>
              </div>
            </li>
            <li v-if="usable.length === 0">
              <p class="empty pb-2x">———— 没有可用的优惠券 ————</p>
            </li>
          </ul>

        </van-tab>
        <van-tab title="不可用优惠券">
          <ul style="height: calc(80vh - 94px); overflow-y: auto">
            <li v-for="temp in disable" :Key="temp.id"
                class="flex-between coupon"
            >
              <div class="ph-2x flex-grow">
                <h4>{{ temp.product.name }}</h4>
                <div class="flex-start">
                  <p class="font-s mt-x flex-shrink" v-if="temp.product.card_least_cost"> 购满{{ temp.product.card_least_cost }}元可用 </p>
                  <p class="font-s mt-x flex-shrink" v-else> 无门槛 </p>
                  <p class="font-s mt-x pl-1x text-nowrap-1"> {{ temp.product.remark }} </p>
                </div>
                <p class="font-s mt-x">每日使用时段: {{ temp.product.time_start }} ~ {{ temp.product.time_start }}</p>
                <p class="font-s mt-x"
                   v-if="temp.product.card_date_type === 'RANGE'"
                >{{ temp.product.card_start_date | date }}至{{ temp.product.card_end_date | date }}有效
                </p>
                <p class="font-s mt-x" v-else>
                  <span v-if="temp.product.card_fixed_begin_term">领取{{ temp.product.card_fixed_begin_term }}天后生效,</span>
                  <span v-else>领取后立即生效,</span>
                  <span>生效后{{ temp.product.card_fixed_term }}天内使用</span>
                </p>
              </div>
              <div class="action pv-1x text-c flex-shrink" :style="{background: temp.product.card_color}">
                <div class="flex-center mt-3x white">
                  <p class="font-l mt-x">¥</p>
                  <h1 class="mh-x">{{ temp.product.unit_price }}</h1>
                </div>
                <ul class="gap">
                  <li class="circle" v-for="item in 11" :key="item"></li>
                </ul>
              </div>
            </li>
            <li v-if="disable.length === 0">
              <p class="empty pb-2x">———— 暂无优惠价 ————</p>
            </li>
          </ul>

        </van-tab>
      </van-tabs>
<!--      <div class="bd-b action-title">-->
<!--        <div class="flex-between">-->
<!--          <h4>可用优惠券</h4>-->
<!--          <van-icon name="close" size="18" @click="showCoupon = false" />-->
<!--        </div>-->
<!--&lt;!&ndash;        <p class="font-s mt-1x">已选中优惠券{{ useCoupons.length }}张，共抵扣 <span class="red">¥{{ couponMoney }}</span></p>&ndash;&gt;-->
<!--      </div>-->
      <footer class="btn-bottom" v-show="showBtn">
        <van-button type="info" block @click="sure">确定</van-button>
      </footer>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'SelectCoupon',
  props: {
    value: {
      type: Boolean,
      default() {
        return false
      }
    },
    usable: { // 可用
      type: Array,
      default() {
        return []
      }
    },
    disable: { // 不可用
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      showCoupon: false,
      showBtn: false,
      active: 0,
      canUse: [], // 可用优惠券
      noUse: [],
      // useCoupons:[],
      // couponMoney: 0,
    }
  },
  watch: {
    value(n) {
      this.showCoupon = n
    }
  },
  methods: {
    sure() {
      this.showCoupon = false
      this.showBtn = false
      let t = setTimeout(() => {
        this.closed()
        clearTimeout(t)
        t = null
      }, 300)
    },
    opened() {
      this.showBtn = true
    },
    closed() {
      this.$emit('input', false)
    },
    selectCoupon(temp) {
      this.$emit('selected', temp)
    }
  }
}
</script>

<style scoped lang="less">
  .action-title {
    position: sticky;
    top: 0;
    left: 0;
    padding: 12px 16px;
    background: #fff;
    z-index: 20;
  }
  /*优惠券*/
  .coupon {
    margin: 12px;
    border-radius: 8px;
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.12);
    background: #fff;

    .action {
      position: relative;
      box-sizing: border-box;
      width: 134px;
      height: 102px;
      background: #1989fa;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;

      h1 {
        font-size: 32px
      }

      .gap {
        position: absolute;
        top: 0;
        right: 131px;

        .circle {
          margin-top: 3px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #fff;
        }
      }

      .select {
        position: absolute;
        right: 8px;
        bottom: 8px;
      }
    }
  }
</style>
